<div style="background: #ececec; min-height: 100vh; padding: 20px">
  <div
    nz-row
    [nzGutter]="24"
    *ngIf="user.role === 'admin'"
    class="dashboard-container"
  >
    <!-- Header Section -->
    <nz-card nz-col nzSpan="24" class="dashboard-header">
      <div>
        <h1 class="dashboard-title">Admin Analytics Center</h1>
        <p class="dashboard-subtitle">Test Series Management Overview</p>
      </div>
      <!-- Summary Cards -->
      <div nz-col nzSpan="24">
        <div class="metric-card-container" nz-row [nzGutter]="16">
          <!-- Total Test Series -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card series-total">
              <nz-statistic
                [nzValue]="(totalTestSeriesCount | number)!"
                [nzTitle]="'Total Test-Series'"
                [nzValueStyle]="{ color: '#3F51B5', fontWeight: 'bold' }"
                [nzPrefix]="seriesIcon"
              ></nz-statistic>
              <ng-template #seriesIcon
                ><i nz-icon nzType="database" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>

          <!-- Paid Series -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card series-paid">
              <nz-statistic
                [nzValue]="(totalPaidTestSeriesCount | number)!"
                [nzTitle]="'Paid Series'"
                [nzValueStyle]="{ color: '#009688', fontWeight: 'bold' }"
                [nzPrefix]="paidIcon"
              ></nz-statistic>
              <ng-template #paidIcon
                ><i nz-icon nzType="dollar" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>

          <!-- Unpaid Series -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card series-unpaid">
              <nz-statistic
                [nzValue]="(totalUnpaidTestSeriesCount | number)!"
                [nzTitle]="'Free Series'"
                [nzValueStyle]="{ color: '#FF9800', fontWeight: 'bold' }"
                [nzPrefix]="unpaidIcon"
              ></nz-statistic>
              <ng-template #unpaidIcon
                ><i nz-icon nzType="gift" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>

          <!-- Total Tests -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card tests-total">
              <nz-statistic
                [nzValue]="(totalTestCount | number)!"
                [nzTitle]="'Total Tests'"
                [nzValueStyle]="{ color: '#E91E63', fontWeight: 'bold' }"
                [nzPrefix]="testIcon"
              ></nz-statistic>
              <ng-template #testIcon
                ><i nz-icon nzType="file-text" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>

          <!-- Total Questions -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card questions-total">
              <nz-statistic
                [nzValue]="(totalQuestionCount | number)!"
                [nzTitle]="'Total Questions'"
                [nzValueStyle]="{ color: '#673AB7', fontWeight: 'bold' }"
                [nzPrefix]="questionIcon"
              ></nz-statistic>
              <ng-template #questionIcon
                ><i nz-icon nzType="question-circle" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>

          <!-- Total Users -->
          <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="4">
            <nz-card class="metric-card users-total">
              <nz-statistic
                [nzValue]="(userCount | number)!"
                [nzTitle]="'Total Users'"
                [nzValueStyle]="{ color: '#2196F3', fontWeight: 'bold' }"
                [nzPrefix]="userIcon"
              ></nz-statistic>
              <ng-template #userIcon
                ><i nz-icon nzType="team" nzTheme="outline"></i
              ></ng-template>
            </nz-card>
          </div>
        </div>
      </div>
    </nz-card>

    <!-- Charts Section -->
    <div nz-col nzSpan="24" class="charts-section">
      <nz-card>
        <div class="chart-header">
          <h3>Usage Analytics</h3>
          <div class="date-picker-container">
            <nz-range-picker
              [nzRanges]="ranges"
              ngModel
              (ngModelChange)="onChange($event)"
              nzSize="large"
              class="custom-range-picker"
            ></nz-range-picker>
          </div>
        </div>
        <div>
          <div class="chart-container">
            <apx-chart
              [series]="chartOptions.series!"
              [labels]="chartOptions.labels!"
              [chart]="chartOptions.chart!"
              [dataLabels]="chartOptions.dataLabels!"
              [plotOptions]="chartOptions.plotOptions!"
              [yaxis]="chartOptions.yaxis!"
              [xaxis]="chartOptions.xaxis!"
              [fill]="chartOptions.fill!"
              [title]="chartOptions.title!"
            ></apx-chart>
          </div>
        </div>
      </nz-card>
    </div>
  </div>
  <!-- Sub-Admin Welcome Dashboard with Mocksala Color Scheme -->
  <div
    nz-row
    [nzGutter]="{ xs: 8, sm: 16, md: 16, lg: 16 }"
    *ngIf="user.role === 'subAdmin'"
  >
    <nz-card
      class="welcome-container"
      nz-col
      nzLg="24"
      nzMd="24"
      nzSm="24"
      nzXs="24"
    >
      <!-- Header with gradient background - Using Mocksala colors -->
      <div class="welcome-header">
        <div class="ant-row" style="display: flex; align-items: center">
          <div class="ant-col" style="flex: 1">
            <h1 style="color: white; margin-bottom: 8px; font-size: 28px">
              Welcome, {{ user.name }} 👋
            </h1>
            <p style="color: rgba(255, 255, 255, 0.9); font-size: 16px">
              We're glad to see you again. Explore assigned sections of the
              application.
            </p>
          </div>
          <div class="ant-col" style="flex: 0 0 200px">
            <nz-empty [nzNotFoundContent]="null"></nz-empty>
          </div>
        </div>

        <!-- Flying bee image -->
      </div>

      <!-- Empty Dashboard Section -->
    </nz-card>
  </div>
</div>
